import { FORMATIONS, type FormationId } from "../domain/club";
import type { MatchLineupPlayer, PlayerState, TeamId } from "./types";

const DEFAULT_NUMBERS = [1, 3, 4, 5, 2, 6, 8, 10, 11, 9, 7];

export function createTeam(
  team: TeamId,
  formationId: FormationId = "4-3-3",
  lineup?: MatchLineupPlayer[]
): PlayerState[] {
  return FORMATIONS[formationId].slots.map((slot, index) => {
    const direction = team === "home" ? 1 : -1;
    const identity = lineup?.[index];
    return {
      id: `${team}-${index + 1}`,
      team,
      shirtNumber: identity?.number ?? DEFAULT_NUMBERS[index]!,
      role: slot.role,
      profileId: identity?.profileId,
      displayName: identity?.displayName,
      x: slot.anchorX * direction,
      z: slot.anchorZ * direction,
      vx: 0,
      vz: 0,
      heading: team === "home" ? 0 : Math.PI,
      stamina: 1,
      action: "idle",
      actionNonce: 0
    };
  });
}

export function formationAnchor(
  player: PlayerState,
  formationId: FormationId = "4-3-3"
): { x: number; z: number } {
  const template = FORMATIONS[formationId].slots[Number(player.id.split("-")[1]) - 1];
  if (!template) return { x: player.x, z: player.z };
  const direction = player.team === "home" ? 1 : -1;
  return {
    x: template.anchorX * direction,
    z: template.anchorZ * direction
  };
}
